import { useEffect, useState } from 'react';

import { AccessTime, Clear } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useSelector } from 'react-redux';

import CustomButton from '../../../components/Button';
import { Loader } from '../../../components/Loader/Loader';
import { sendResetRequest, setIsResendDisabled } from '../../../slices/auth.slice';
import { closeModal } from '../../../slices/modal.slice';
import { RootState } from '../../../store';
import { useAppDispatch } from '../../../store/hooks';
import styles from '../../ForgotPassword/ForgotPassword.module.scss';

const ForgotPasswordModal = () => {
  const dispatch = useAppDispatch();
  const [timer, setTimer] = useState(60);
  const { isResendDisabled, loading, forgotPasswordForm } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    let interval: any;
    if (isResendDisabled) {
      interval = setInterval(() => {
        setTimer((prevTimer: number) => {
          if (prevTimer <= 1) {
            clearInterval(interval);
            dispatch(setIsResendDisabled(false));
            return 60;
          }
          return prevTimer - 1;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [isResendDisabled, dispatch]);

  return (
    <div className={styles.customModalContentWrapper}>
      <h6>Check your email!</h6>
      <IconButton className={styles.close} onClick={() => dispatch(closeModal())}>
        <Clear />
      </IconButton>
      <p>
        Thanks! An email was sent that will ask you to click on a link to verify that you own this account.
        {/* If you don't
        get the email, please contact.{' '}
        <span>
          <a href='support@idr.com'>support@idr.com</a>
        </span> */}
      </p>
      {isResendDisabled && (
        <div className={styles.timerClass}>
          <AccessTime />
          00:{timer} Sec
        </div>
      )}
      <CustomButton
        variant='contained'
        sx={{
          marginTop: '20px',
          width: '80%',
        }}
        onClick={() => dispatch(sendResetRequest(forgotPasswordForm))}
        disabled={isResendDisabled || loading}
      >
        {loading ? <Loader type='button' /> : 'Resend Email'}
      </CustomButton>
    </div>
  );
};

export default ForgotPasswordModal;
